import { identityCardType } from 'json/customer-options'
import { channelOptions } from 'json/goods-order-options'
import { getEnumeration } from 'enumeration'
import { cashCount } from '@/utils/formUtils'
import timeutils from 'utils/wt-time-utils'
import { paymentStatesOfScan } from 'json/payment'
import { qrCodeBusinessTypes, qrCodeBusinessTypesOfStorage } from 'json/index'

export default {
  getTaxProjctList (data) {
    data.forEach(item => {
      item.rate = item.sl && item.sl + '%'
    })
    return data
  },
  consultantPaymentOrder (data) {
    let typesOfAll = [...qrCodeBusinessTypesOfStorage, ...qrCodeBusinessTypes]
    data.forEach(item => {
      let paymentInfo = item.paymentInfo || {}
      let paymentDetails = item.paymentDetails || {}
      paymentInfo.identity_card_type = paymentInfo.identityCardType && getEnumeration(paymentInfo.identityCardType, identityCardType)
      paymentDetails.paymentChannel = paymentDetails.channel && getEnumeration(paymentDetails.channel, channelOptions)
      paymentDetails.amount_show = paymentDetails.amount && '¥' + cashCount(paymentDetails.amount, true, 2)
      paymentDetails.payNumber = paymentDetails.payNumber || '--'
      item.created_date = item.createdDate && timeutils.format(item.createdDate)
      item.lastModified_date = item.lastModifiedDate && timeutils.format(item.lastModifiedDate)
      item.status_show = (item.status && getEnumeration(item.status, paymentStatesOfScan)) || null
      item.thirdNumber = item.thirdNumber || '--'
      item.type_text = item.type && getEnumeration(item.type, typesOfAll)
    })
    return data
  }
}
